import CardGuidance from './CardGuidance.vue'

export default CardGuidance
